import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { SettingResponse } from 'src/app/models/setting';
import { SettingsService } from '../settings.service';
import * as settingsActions from './settings.actions';

@Injectable({
  providedIn: 'root'
})
export class SettingsEffects {

  constructor(private actions$: Actions,
    private settingsService: SettingsService) { }

  loadSettings$ = createEffect(() => this.actions$.pipe(
    ofType(settingsActions.SettingsActionTypes.Load),
    mergeMap((action: settingsActions.Load) => this.settingsService.getSettings().pipe(
      map((settings: SettingResponse) => (new settingsActions.LoadSuccess(settings.settings))),
      catchError(err => {
        let errMsg = '';
        if (err.hasOwnProperty('statusText')) {
          errMsg = err.statusText;
        } else {
          errMsg = err;
        }
        return of(new settingsActions.LoadFail(errMsg));
      })
    ))
  ));
}
